/** The shape of what is coming, while it comes.
 *
 *  Firestore answers in a few hundred milliseconds on a good connection and in
 *  a couple of seconds on a bad one. A spinner for that long says nothing is
 *  happening; rows already in their places say the list is arriving.
 *
 *  The three shapes a row is made of are named in the stylesheet rather than
 *  written inline, because these rows are drawn twice: once here, and once by
 *  hand in index.html, which is what stands on the screen before any of this
 *  has been downloaded. Two copies of a list of pixel values would drift. */

export function Line({ w = "100%", h = 13 }: { w?: number | string; h?: number }) {
  return <div className="skeleton" style={{ width: w, height: h }} />;
}

export function ListSkeleton({ rows = 5 }: { rows?: number }) {
  return (
    <div aria-hidden="true">
      {Array.from({ length: rows }, (_, i) => (
        <div
          className="listrow"
          key={i}
          style={{ opacity: 1 - i * 0.14, pointerEvents: "none" }}
        >
          <div className="skeleton sk-avatar" />
          <div className="grow sk-lines">
            <Line w={`${52 + ((i * 13) % 30)}%`} h={14} />
            <Line w={`${34 + ((i * 17) % 24)}%`} h={11} />
          </div>
          <div className="skeleton sk-pill" />
        </div>
      ))}
    </div>
  );
}
